// Basic
import { useState } from 'react';
import PropTypes from 'prop-types';
// Store & actions
import useSessionStore from '@/app/store/session';
// Components
import ModalFunctionNotActivated from '@/common-utils/components/renders/modal/components/modals/ModalFunctionNotActivated/ModalFunctionNotActivated';
import ModalGeolocation from '../modals/geolocation/ModalGeolocation';
import { Button } from '@/common-utils/components/ui/button';
// Common
import hasRequiredPermissions from '@/common-utils/functions/hasRequiredPermissions';
import Permissions from '@/app/permissions/Permissions';
import NETWORK_INTERFACE_TYPE from '../../enums/NetworkInterfaceType';
import ICONS from '@/common-utils/enums/icons';
// Lang
import { nsTerminal } from '@/app/i18n/namespaces';
import getTranslatedText from '@/common-utils/functions/getTranslatedText';

/**
 *
 * @param root0
 * @param root0.connectionType
 * @param root0.sourceAddressIp
 * @param root0.posTerminalUuid
 * @returns {JSX} PosTerminalLocation
 */
function PosTerminalLocation({ connectionType, sourceAddressIp, posTerminalUuid }) {
    // Constants
    const interfaceTypeGprs = connectionType === NETWORK_INTERFACE_TYPE.GPRS.name;
    const modalBody = interfaceTypeGprs || !posTerminalUuid ? 'modal.geolocation.not_activated.text' : 'modal.function_not_activated.text';

    // Store
    const { permissions } = useSessionStore(s => s.session);

    // State
    const [showModalFunctionNotActivated, setShowModalFunctionNotActivated] = useState(false);
    const handleShowModalFunctionNotActivated = () => {
        setShowModalFunctionNotActivated(true);
    };

    const [showModalGeolocation, setShowModalGeolocation] = useState(false);
    const handleShowModalGeolocation = () => {
        setShowModalGeolocation(true);
    };

    // Permissions
    const hasUserGetGeolocalisationPermissions = () => {
        return hasRequiredPermissions({
            permissions: permissions,
            requiredPermissions: [Permissions.GET_GEOLOCATION.name]
        });
    };

    // Render
    return (
        <div>
            <div className='clickable' >
                <Button
                    data-cy='button-pos-geolocation'
                    icon={interfaceTypeGprs || !posTerminalUuid ? ICONS.NO_LOCATION : ICONS.LOCATION}
                    onClick={interfaceTypeGprs || !posTerminalUuid ? handleShowModalFunctionNotActivated : handleShowModalGeolocation}
                    disabled={hasUserGetGeolocalisationPermissions() === false}
                    title={hasUserGetGeolocalisationPermissions() === false ? getTranslatedText('title.permissions.access_denied') : undefined}
                    variant='ghostNoBorder'
                />
            </div>
            <div>
                {
                    showModalFunctionNotActivated &&
                    <ModalFunctionNotActivated
                        isOpen={showModalFunctionNotActivated}
                        setIsOpen={setShowModalFunctionNotActivated}
                        title='modal.geolocation.not_activated.title'
                        body={modalBody}
                        namespace={nsTerminal}
                    />
                }
                {
                    showModalGeolocation &&
                    <ModalGeolocation
                        isOpen={showModalGeolocation}
                        setIsOpen={setShowModalGeolocation}
                        ipAddress={sourceAddressIp}
                        posTerminalUuid={posTerminalUuid}
                    />
                }
            </div>
        </div>
    );
}
PosTerminalLocation.propTypes = {
    connectionType: PropTypes.string,
    sourceAddressIp: PropTypes.string,
    posTerminalUuid: PropTypes.string
};

export default PosTerminalLocation;